module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('header', {
    staticClass: "view__header"
  }, [_c('h2', {
    staticClass: "view__title"
  }, [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c('article', {
    staticClass: "view__content"
  }, [_c('div', {
    staticClass: "view__panel"
  }, [_c('div', {
    staticClass: "multi-step"
  }, [_c('Navigation', {
    attrs: {
      "steps": _vm.steps,
      "currentstep": _vm.currentstep
    }
  }), _vm._v(" "), (_vm.currentstep == 1) ? _c('div', {
    staticClass: "multi-step__step"
  }, [_c('TextBox', {
    attrs: {
      "label": "Label_Name",
      "validate": _vm.$v.model,
      "modelPath": "name",
      "acc": "name"
    },
    on: {
      "input": _vm.$v.model.name.$touch
    },
    model: {
      value: (_vm.model.name),
      callback: function($$v) {
        _vm.$set(_vm.model, "name", $$v)
      },
      expression: "model.name"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.currentstep == 2) ? _c('div', {
    staticClass: "multi-step__step"
  }, [_c('div', {
    staticClass: "cards"
  }, _vm._l((_vm.layouts), function(layout) {
    return _c('div', {
      staticClass: "cards__item",
      on: {
        "click": function($event) {
          return _vm.chooseLayout(layout)
        }
      }
    }, [_c('img', {
      staticClass: "cards__image",
      attrs: {
        "src": layout.img
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "cards__text"
    }, [_c('p', [_vm._v(_vm._s(layout.title))])])])
  }), 0)]) : _vm._e(), _vm._v(" "), _vm._l((_vm.steps), function(step) {
    return (_vm.currentstep != 3) ? _c('Controls', {
      attrs: {
        "step": step,
        "stepcount": _vm.steps.length,
        "currentstep": _vm.currentstep,
        "nextDisabled": step.nextDisabled
      },
      on: {
        "step-change": _vm.stepChanged
      }
    }) : _vm._e()
  })], 2)]), _vm._v(" "), (_vm.currentstep == 3) ? _c('div', [_c('bee', {
    attrs: {
      "clientId": _vm.tenant.beeClientId,
      "clientSecret": _vm.tenant.beeClientSecret,
      "layout": _vm.currentLayout
    },
    on: {
      "onSave": _vm.saveLayout
    }
  })], 1) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5a7f63b3!./~/vue-loader/lib/selector.js?type=template&index=0!./scripts/components/views/templates/Template.vue
// module id = 736
// module chunks = 1